import React, { forwardRef } from 'react'
import { useStyles, ThemeContext } from './useStyles'

const withStyles = (defautStyles, themes) => Component => {
  const ComponentWithStyles = forwardRef((props, ref) => {
    const [styles, theme] = useStyles(defautStyles, themes, props.theme)

    return (
      <Component {...props} ref={ref} theme={theme} styles={styles}/>
    )
  })

  ComponentWithStyles.displayName = Component.displayName

  return ComponentWithStyles
}

export { withStyles, ThemeContext, useStyles }

export default withStyles
